import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function saveCRMCallDetails(payload) {
  validateUserKey(payload.UserKey);
  try {
    const { data } = await apiClient.put("api/saveCRMCallDetails", payload, {
      headers: {
        "x-user-key": payload.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
